import { ordemServicoApi } from '../clients/AxiosClients'

/**
 * Retorna todoas as Ordens de Servicos cadastradas no banco de dados
 */
const recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio = async (idsDePlantios) => {
	return ordemServicoApi.post(
		`/PlanejamentoDeOrdemDeServicoTradicional/recuperar-maior-numero-de-codigo-de-parcela-por-plantio`,
		idsDePlantios,
	)
}

/**
 * Faz o planejamento de ordem de servico tradicional
 */
const ordemDeServicoTradicionalPlanejar = async (dto) => {
	return await ordemServicoApi.post(
		`/PlanejamentoDeOrdemDeServicoTradicional/ordem-de-servico-tradicional-planejar`,
		dto,
	)
}

export { recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio, ordemDeServicoTradicionalPlanejar }
